var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-container',{staticClass:"intonation-sentence"},[_c('jz-container',{staticClass:"sentence"},[_vm._l((_vm.splitSentence),function(ref,index){
var word = ref.word;
var highlight = ref.highlight;
var underline = ref.underline;
return [_c('span',{key:("word-" + index),class:["word", { highlight: highlight, underline: underline }]},[_vm._v(_vm._s(word))]),_c('span',{key:("space-" + index),domProps:{"innerHTML":_vm._s("&MediumSpace;&MediumSpace;")}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }